import { LockOutlined, UnlockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

import Utils from '@utils';

const FormItem = Form.Item;

// Port NGUYÊN VĂN từ ra-log-monitor-cms/source/src/compoments/account/LoginForm.js (nguồn đã là hook).
// Một form dùng cho CẢ HAI bước: chưa có requestToken -> nhập tài khoản/mật khẩu;
// có requestToken -> chỉ hiện ô OTP + link "Quay lại đăng nhập".
const LoginForm = ({ loading, onLogin, requestToken, onLoginOtp, onBack }) => {
    const [form] = Form.useForm();
    const formRef = useRef();

    const handleSubmit = (values) => {
        if (requestToken) onLoginOtp(values);
        else {
            // nguồn: xoá trắng tài khoản/mật khẩu NGAY khi submit bước 1
            form.setFieldsValue({ username: '', password: '' });
            onLogin(values);
        }
    };

    return (
        <Form
            form={form}
            ref={formRef}
            onFinish={handleSubmit}
            className="login-form"
            initialValues={{ username: '', password: '' }}
        >
            {!requestToken ? (
                <>
                    <FormItem
                        name="username"
                        rules={[
                            { required: true, message: 'Hãy nhập tên đăng nhập!' },
                            { validator: Utils.validateUsernameForm },
                        ]}
                    >
                        <Input
                            prefix={<UserOutlined />}
                            size="large"
                            name="username"
                            placeholder="Tên đăng nhập"
                            autoComplete="off"
                            autoCorrect="off"
                            autoSave="off"
                            autoCapitalize="off"
                        />
                    </FormItem>
                    <FormItem name="password" rules={[{ required: true, message: 'Hãy nhập mật khẩu!' }]}>
                        <Input
                            prefix={<LockOutlined />}
                            size="large"
                            name="password"
                            type="password"
                            placeholder="Mật khẩu"
                            autoComplete="off"
                            autoCorrect="off"
                            autoSave="off"
                            autoCapitalize="off"
                        />
                    </FormItem>
                </>
            ) : (
                <FormItem name="otp" rules={[{ required: true, message: 'Hãy nhập mã OTP!' }]}>
                    <Input
                        prefix={<UnlockOutlined />}
                        size="large"
                        name="otp"
                        autoComplete="off"
                        autoCorrect="off"
                        autoSave="off"
                        autoCapitalize="off"
                        placeholder="Mã OTP"
                        maxLength={10}
                    />
                </FormItem>
            )}

            <FormItem>
                <Button loading={loading} type="primary" htmlType="submit" size="large" className="login-form-button">
                    Đăng nhập
                </Button>
            </FormItem>
            {requestToken && (
                <div style={{ textAlign: 'center' }}>
                    <Link
                        to="#"
                        onClick={() => {
                            form.setFieldsValue({ otp: '' });
                            onBack();
                        }}
                    >
                        {' '}
                        &#8592; <small style={{ fontSize: '11.2px' }}>Quay lại đăng nhập</small>{' '}
                    </Link>
                </div>
            )}

            <center className="s-mt4px">
                <small style={{ fontSize: '11.2px' }}>Copyright © IService, All Rights Reserved.</small>
            </center>
        </Form>
    );
};

export default LoginForm;
